import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserTypeEnum } from '../enums/auth';
import { isPublicSharePath } from '../helpers/public-routes';

@Injectable({
  providedIn: 'root',
})
export class UserNavService {
  private router = inject(Router);
  private location = inject(Location);

  getUserNavUrl(userType: UserTypeEnum): string {
    const userTypeToUrlMap: Record<string, string> = {
      [UserTypeEnum.SUPER_ADMIN]: '/dashboard',
      [UserTypeEnum.SHIPPER_ADMIN]: '/booking/dashboard',
      [UserTypeEnum.CARRIER_ADMIN]: '/booking/dashboard',
      [UserTypeEnum.CARRIER_ITURAN]: '/booking/dashboard',
      /** Not a booking route: avoids redirect loops when `roleGuard` excludes this role from `/booking`. */
      [UserTypeEnum.CARRIER_MANAGER]: '/login',
    };

    return userTypeToUrlMap[userType] || '/login';
  }

  navigateByRole(userType: UserTypeEnum): Promise<boolean> {
    const url = this.getUserNavUrl(userType);
    return this.router.navigateByUrl(url);
  }

  navigateTo(path: string): Promise<boolean> {
    return this.router.navigateByUrl(path);
  }

  /** After sign-out: replace history so the booking shell is not kept in the stack. */
  navigateToLogin(): void {
    // Safety net: a sign-out must never send a share-link viewer off the public page.
    if (isPublicSharePath(this.location.path())) {
      return;
    }
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  goBack() {
    this.location.back();
  }

  get isBookingDomain(): boolean {
    return this.router.url.startsWith('/booking');
  }
}
